import { render } from "./ReceiptScanner.vue?vue&type=template&id=3e45bc2c"
import script from "./ReceiptScanner.vue?vue&type=script&lang=js"
export * from "./ReceiptScanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__